/**
 * Build the srcdoc payload for the sandboxed HTML iframe.
 *
 * Defense-in-depth: even with `sandbox=""` neutralising script + form
 * execution, inline CSP also blocks remote resource loads (tracking
 * pixels, beacon stylesheets, `<link rel=preload>`, SVG `<use href>`).
 * `frame-src` / `child-src` are explicit alongside `default-src` —
 * `default-src` covers nested frames in modern browsers but the
 * explicit directives are harmless belt-and-suspenders.
 */

const CSP = [
  "default-src 'none'",
  "img-src data:",
  "style-src 'unsafe-inline'",
  "frame-src 'none'",
  "child-src 'none'",
  "form-action 'none'",
  "base-uri 'none'",
].join("; ");

export function buildSandboxedHtml(body: string): string {
  return `<!doctype html><html><head><meta http-equiv="Content-Security-Policy" content="${CSP}"></head><body>${body}</body></html>`;
}
